import React from 'react';
import { I18nManager } from 'react-native';
import { useTheme } from 'react-native-paper';
import Slider from 'react-slick';
import SlickList from 'react-slick';
import styled from 'styled-components/native';

import { windowWidth } from '@src/configuration/constants';

import { CarouselProps, PaginationProps } from './types';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const DotsWrapper = styled.View`
margin-top: -20,
background-color:${({ theme }) => theme.colors.primary},
z-Index: 2000,
`;

export const Pagination: React.FC<PaginationProps> = ({
  children,
  ..._props
}) => {
  return <DotsWrapper>{children}</DotsWrapper>;
};

const ItemContainer = styled.View<{ width?: number }>`
  margin: auto;
  width: ${({ width }) => width ?? windowWidth * 0.95}px;
`;

const Carousel: React.FC<CarouselProps<any>> = ({
  loop,
  onSnapToItem,
  renderItem,
  firstItem,
  data,
  itemWidth,
  sliderWidth,
  dots = true,
}) => {
  const [activeIndex, SetActiveIndex] = React.useState(0);
  const ref = React.useRef<Slider>(null);
  const handleAfterChange = React.useCallback(
    (currentSlide: number) => {
      SetActiveIndex(currentSlide);
      onSnapToItem?.(currentSlide);
    },
    [onSnapToItem]
  );
  const theme = useTheme();

  return (
    <Slider
      ref={ref}
      infinite={loop}
      dots={dots}
      appendDots={(dots) => (
        <ul
          style={{
            margin: '0px',
            display: 'inline-block',
            bottom: '20px',
          }}
        >
          {dots}
        </ul>
      )}
      customPaging={(i) => (
        <a
          style={
            activeIndex == i
              ? {
                  width: 12,
                  height: 12,
                  borderRadius: 25,
                  display: 'inline-block',
                  backgroundColor: theme.colors.primary,
                  backgroundSize: 'contain',
                  backgroundRepeat: 'no-repeat',
                }
              : {
                  width: 8,
                  height: 8,
                  display: 'inline-block',
                  backgroundColor: '#BFE1DF',
                  borderRadius: 25,
                  backgroundRepeat: 'no-repeat',
                }
          }
          className="slick-dot"
        />
      )}
      slidesToShow={
        sliderWidth && itemWidth ? Math.floor(sliderWidth / itemWidth) : 1
      }
      centerMode
      centerPadding="-2"
      slidesToScroll={1}
      arrows={false}
      rtl={I18nManager.isRTL}
      afterChange={handleAfterChange}
      initialSlide={
        I18nManager.isRTL && firstItem !== undefined
          ? data.length - firstItem - 1
          : firstItem
      }
    >
      {
        // @ts-ignore
        data.map((item, index) => (
          <div key={index}>
            <ItemContainer width={itemWidth}>
              {renderItem({ item, index })}
            </ItemContainer>
          </div>
        ))
      }
    </Slider>
  );
};

export default React.memo(Carousel);
